import { Controller } from "@hotwired/stimulus"

// Собирает изменённые коды цветов и постит их в update_custom_colors (JSON).
export default class extends Controller {
  static targets = ["code", "status"]
  static values = { url: String }

  submit() {
    const map = {}
    this.codeTargets.forEach((input) => {
      map[input.dataset.index] = { code: input.value.trim() }
    })

    this.statusTarget.textContent = "Отправка…"
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ custom_colors_map: map }),
    })
      .then((r) => r.json())
      .then((data) => {
        this.statusTarget.textContent = data.success ? data.message : `Ошибка: ${data.error}`
      })
      .catch((e) => { this.statusTarget.textContent = `Ошибка: ${e.message}` })
  }
}
